// extracted by mini-css-extract-plugin
export default {"box__container":"BoxEditor_box__container__2hF6L","box__editor":"BoxEditor_box__editor__MqbRO","box__body":"BoxEditor_box__body__JVkqK","box_button":"BoxEditor_box_button__0bgYH"};